import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import UpdateData from './update-data.mdx';
import Style from './style.mdx';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`initialTick`}</strong><br />{`number, optional, default 0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The initial value for `}<inlineCode parentName="td">{`tick`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`initalParams`}</strong><br />{`object, optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The initial value for the `}<inlineCode parentName="td">{`params`}</inlineCode>{` of the simulation. When the simulation starts, it is used to populate `}<inlineCode parentName="td">{`params`}</inlineCode>{` in the state.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`The following properties can be used as is, or be passed inside `}<inlineCode parentName="p">{`initialParams`}</inlineCode>{`,i.e.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Model delay={100} />
`}</code></pre>
    <p>{`or`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Model initialParams={{ delay: 100 }} />
`}</code></pre>
    <p><inlineCode parentName="p">{`initialParams`}</inlineCode>{` takes precedence if both are used. They provide an initial value for the corresponding parts of the state.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`delay`}</strong><br />{`number, optional, default 0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The delay between each animation refresh. If not specified, animations happen as fast as possible (up to 60 times per second).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`minTime`}</strong><br />{`integer, optional, default 0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The value of `}<inlineCode parentName="td">{`tick`}</inlineCode>{` when the animation starts`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`maxTime`}</strong><br />{`integer, optional, default 100`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The value of `}<inlineCode parentName="td">{`tick`}</inlineCode>{` at which the animation stops`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`ticksPerAnimation`}</strong><br />{`integer, optional, default 1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The number of simulation ticks per animation refresh. If more than one, the simulation will update several times before it's rendered again.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`isPlaying`}</strong><br />{`boolean, default false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether the simulation plays automatically or not. If this is updated by external components, the simulation will stop or resume.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`loop`}</strong><br />{`boolean, default false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If set to true, the simulation restarts whenever it's stopped playing.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`nocache`}</strong><br />{`boolean, default false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If set to true, the simulation won't cache its data. If data is cached, then the user can go back in time without having to recalculate data.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`controls`}</strong><br />{`control object, optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Describes the UI of the simulation. Controls is how the `}<inlineCode parentName="td">{`params`}</inlineCode>{` in the state can be modified.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`noControls`}</strong><br />{`boolean, optional, default false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If set to true, the default controls won't be shown.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`showTimer`}</strong><br />{`boolean, optional, default true`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If set to false, the default timer won't be displayed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`showTime`}</strong><br />{`boolean, optional, default true`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If set to false, only the play, stop and step-in button will be displayed, the slider and the indication of time won't be shown.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`showTimerSlider`}</strong><br />{`boolean, optional, default true`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If set to false, the timer slider won't be displayed, though the indication of time may be.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`initData`}</strong><br />{`function, optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The function that initializes the `}<inlineCode parentName="td">{`data`}</inlineCode>{` of the model, when it first starts or when it's reset.`}<br />{`It takes `}<inlineCode parentName="td">{`params`}</inlineCode>{` (in the state) as input, and outputs a value for `}<inlineCode parentName="td">{`data`}</inlineCode>{` (which it puts in the state).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`updateData`}</strong><br />{`function, optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This function updates the `}<inlineCode parentName="td">{`data`}</inlineCode>{` at each tick of the simualtion`}</td>
        </tr>
      </tbody>
    </table>
    <UpdateData mdxType="UpdateData" />
    <Style mdxType="Style" />


export const _frontmatter = {}
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      